import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { adminCustomers, formatMoney } from "@/lib/api";
import { AdminHeader, fieldCls } from "./ui";

const totals = (t) => Object.entries(t).map(([cur, v]) => formatMoney(v, cur)).join(" · ");

export default function AdminCustomers() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [open, setOpen] = useState("");
  useEffect(() => { adminCustomers().then(setItems); }, []);
  const list = items.filter((c) => `${c.nombre} ${c.email} ${c.libros.map((l) => l.titulo).join(" ")}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <AdminHeader title="Clientes" subtitle={`${items.length} cliente(s) que han comprado ebooks`} />
      <div className="relative max-w-sm mb-4">
        <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8a8a83]" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar por nombre, email o libro" className={`${fieldCls} pl-9`} data-testid="customers-search" />
      </div>
      <div className="overflow-x-auto rounded-xl bg-white border border-[#0f2544]/8" data-testid="customers-table">
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-[#8a8a83] border-b border-[#0f2544]/8">
            <tr><th className="px-4 py-3">Cliente</th><th className="px-4 py-3">Email</th><th className="px-4 py-3">Libros comprados</th><th className="px-4 py-3">Total gastado</th><th className="px-4 py-3">Última compra</th></tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-[#8a8a83]">Aún no hay clientes.</td></tr>}
            {list.map((c) => (
              <tr key={c.email} className="border-b border-[#0f2544]/5 align-top" data-testid={`customer-row-${c.email}`}>
                <td className="px-4 py-3 font-medium text-[#0f2544]">{c.nombre}</td>
                <td className="px-4 py-3"><a href={`mailto:${c.email}`} className="text-[#1f44e0] hover:underline">{c.email}</a></td>
                <td className="px-4 py-3">
                  <button onClick={() => setOpen(open === c.email ? "" : c.email)} className="text-left text-[#0f2544] hover:text-[#1f44e0]" data-testid={`customer-books-${c.email}`}>
                    {c.compras} libro(s) {open === c.email ? "▴" : "▾"}
                  </button>
                  {open === c.email && (
                    <ul className="mt-2 space-y-1 text-xs text-[#4a4a45]">
                      {c.libros.map((l) => <li key={`${l.numero_factura}-${l.fecha}-${l.titulo}`}>{l.fecha} · {l.titulo} · {formatMoney(l.total, l.moneda)} {l.numero_factura && `· ${l.numero_factura}`}</li>)}
                    </ul>
                  )}
                </td>
                <td className="px-4 py-3 whitespace-nowrap">{totals(c.totales)}</td>
                <td className="px-4 py-3 whitespace-nowrap">{c.ultima_compra.slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
